import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { Container, ModalContainer } from '../BaseModal';
import { BodyLarge, TitleLarge } from '../Texts';
import LoadingSpinner from '../LoadingSpinner';

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
`;

const BRIDGE_TOS_CALLBACK = 'BRIDGE_TOS_CALLBACK';

const BridgeCallback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const signedAgreementId = searchParams.get('signed_agreement_id');
    const error = searchParams.get('error');

    if (signedAgreementId) {
      // Success - send the signed agreement ID back to parent window
      const message = {
        type: BRIDGE_TOS_CALLBACK,
        success: true,
        signedAgreementId,
      };

      if (window.parent && window.parent !== window) {
        window.parent.postMessage(message, '*');
      }
    } else if (error) {
      // Error case
      const message = {
        type: BRIDGE_TOS_CALLBACK,
        success: false,
        error,
      };

      if (window.parent && window.parent !== window) {
        window.parent.postMessage(message, '*');
      }
    } else {
      // No params - something went wrong
      const message = {
        type: BRIDGE_TOS_CALLBACK,
        success: false,
        error: 'No signed_agreement_id received',
      };

      if (window.parent && window.parent !== window) {
        window.parent.postMessage(message, '*');
      }
    }
  }, [searchParams]);

  return (
    <Container>
      <ModalContainer>
        <LoadingContainer>
          <LoadingSpinner />
          <TitleLarge>Processing Terms of Service</TitleLarge>
          <BodyLarge>
            Please wait while we complete your TOS acceptance...
          </BodyLarge>
        </LoadingContainer>
      </ModalContainer>
    </Container>
  );
};

export default BridgeCallback;
export { BRIDGE_TOS_CALLBACK };
